import { render, staticRenderFns } from "./FootprintDetail.vue?vue&type=template&id=03c2935c&scoped=true&"
import script from "./FootprintDetail.vue?vue&type=script&lang=js&"
export * from "./FootprintDetail.vue?vue&type=script&lang=js&"
import style0 from "./FootprintDetail.vue?vue&type=style&index=0&id=03c2935c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c2935c",
  null
  
)

export default component.exports